module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":{"form":"Form","state":"State"}}}')
  delete Component.options._Ctor
}
